import { Button, InputGroup, NumericInput } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from 'Styles/styles.module.css';

const BOSInput = ({
  key,
  value,
  onChange,
  onBlur,
  isRequired = false,
  showClear = false,
  onClear,
  isMoneyInput = false,
  isNumericalInput = false,
  ...props
}) => {
  const clearValue = () => {
    onChange('');
    onBlur && onBlur();
  };

  const clearButton = showClear && value?.length > 0 && (
    <Button
      minimal
      small
      style={{ marginLeft: 'auto' }}
      icon={'cross'}
      onClick={onClear ? onClear : clearValue}
    />
  );

  let fieldRequiredAndMissing = isRequired && !value;

  return isMoneyInput ? (
    <NumericInput
      key={key || 0}
      className={showClear ? styles.bos_input : styles.bos_money_input}
      leftIcon={'dollar'}
      rightElement={clearButton}
      intent={`${fieldRequiredAndMissing ? 'danger' : ''}`}
      defaultValue={value}
      onValueChange={(valueAsNumber) => {
        onChange(valueAsNumber);
      }}
      buttonPosition={'none'}
      onBlur={onBlur}
    />
  ) : isNumericalInput ? (
    <NumericInput
      key={key || 0}
      className={
        showClear ? styles.bos_numerical_input : styles.bos_money_input
      }
      rightElement={clearButton}
      intent={`${fieldRequiredAndMissing ? 'danger' : ''}`}
      onValueChange={(valueAsNumber) => {
        onChange(valueAsNumber);
      }}
      buttonPosition={'none'}
      onBlur={onBlur}
    />
  ) : (
    <InputGroup
      key={key || 0}
      fill
      type='text'
      className={
        fieldRequiredAndMissing ? styles.required_input : styles.bos_input
      }
      rightElement={clearButton}
      intent={fieldRequiredAndMissing ? 'danger' : ''}
      value={value || ''}
      placeholder={`${props.placeholder ? props.placeholder + ' ' : ''}${
        fieldRequiredAndMissing ? '(Required)' : ''
      }`}
      onChange={(e) => {
        onChange(e.target.value);
        onBlur && onBlur();
      }}
      onBlur={onBlur}
      {...props}
    />
  );
};

BOSInput.propTypes = {
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  isRequired: PropTypes.bool,
  showClear: PropTypes.bool,
  onClear: PropTypes.func,
  onBlur: PropTypes.func,
  isMoneyInput: PropTypes.bool,
  isNumericalInput: PropTypes.bool,
};

export default BOSInput;
